import { AxiosResponse } from 'axios';
import FileSaver from 'file-saver';

export function handleSaveFile(response: AxiosResponse) {
    try {
        const filename = decodeURI(response.headers['content-disposition'].split('filename=')[1].split(';')[0]).replaceAll('"', '');
        const type = response.headers['content-type'];
        const blob = new Blob([response.data], { type });
        FileSaver.saveAs(blob, filename);
    } catch (error) {
        console.error('error: ', error);
    }
}

export function getIdFolderDriveFromURL(URL: string | undefined) {
    if (!URL || URL.length <= 0) return undefined;
    const regexList = [
        /\/drive\/folders\/([a-zA-Z0-9_-]+)/,
        /\/drive\/u\/\d+\/folders\/([a-zA-Z0-9_-]+)/,
        /open\?id=([a-zA-Z0-9_-]+)/,
        /uc\?id=([a-zA-Z0-9_-]+)/,
        /id=([a-zA-Z0-9_-]+)/
    ];

    for (const regex of regexList) {
        const match = URL.match(regex);
        if (match && match[1]) {
            return match[1];
        }
    }
    return undefined;
}
